import React from 'react';
import { TextInput, TextArea, SectionHeader, Field } from './Fields';
import ImageUpload from './ImageUpload';

const BTN_STYLES = [
  { value: 'solid',   label: 'Sólido' },
  { value: 'outline', label: 'Contorno' },
  { value: 'link',    label: 'Link sublinhado' },
];

const BTN_COLORS = [
  { value: 'orange', label: 'Laranja', bg: '#F47920', text: '#fff' },
  { value: 'blue',   label: 'Azul',    bg: '#1B4F8A', text: '#fff' },
  { value: 'white',  label: 'Branco',  bg: '#ffffff', text: '#1B4F8A' },
  { value: 'dark',   label: 'Escuro',  bg: '#0f172a', text: '#fff' },
];

const ButtonConfigurator = ({ label, textKey, styleKey, colorKey, data, set }) => {
  const style = data[styleKey] || 'solid';
  const color = data[colorKey] || 'orange';
  return (
    <Field label={label}>
      <div className="space-y-3">
        <TextInput label="" value={data[textKey]} onChange={v => set(textKey, v)} placeholder="Texto do botão" />
        <div className="flex gap-3">
          <div className="flex-1">
            <p className="text-xs font-semibold text-gray-500 mb-1.5">Estilo</p>
            <div className="flex gap-2">
              {BTN_STYLES.map(s => (
                <button
                  key={s.value}
                  onClick={() => set(styleKey, s.value)}
                  className={`px-3 py-1.5 rounded-lg text-xs font-semibold border-2 transition-all ${
                    style === s.value ? 'border-blue-500 bg-blue-50 text-blue-700' : 'border-gray-200 text-gray-500 hover:border-gray-300'
                  }`}
                >
                  {s.label}
                </button>
              ))}
            </div>
          </div>
          <div className="flex-1">
            <p className="text-xs font-semibold text-gray-500 mb-1.5">Cor</p>
            <div className="flex gap-2">
              {BTN_COLORS.map(c => (
                <button
                  key={c.value}
                  onClick={() => set(colorKey, c.value)}
                  title={c.label}
                  className={`w-8 h-8 rounded-lg border-2 transition-all ${color === c.value ? 'border-blue-500 scale-110' : 'border-gray-200'}`}
                  style={{ background: c.bg }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Field>
  );
};

const HeroEditor = ({ data, onChange }) => {
  const set = (key, val) => onChange({ ...data, [key]: val });

  return (
    <div>
      <SectionHeader title="Seção Hero — Cabeçalho principal do site" />
      <TextInput label="Badge (etiqueta)" value={data.badge} onChange={v => set('badge', v)} placeholder="Ex: Gestão Pública Inteligente" />
      <TextArea label="Título principal" value={data.heading} onChange={v => set('heading', v)} rows={2} placeholder="Planejamento, controle e gestão..." />
      <TextInput label="Parte destacada do título" value={data.heading_highlight} onChange={v => set('heading_highlight', v)} hint="Deve ser parte exata do título acima" />
      <TextArea label="Subtítulo / descrição" value={data.subheading} onChange={v => set('subheading', v)} rows={3} />

      <ButtonConfigurator
        label="Botão primário"
        textKey="cta_primary" styleKey="cta_primary_style" colorKey="cta_primary_color"
        data={data} set={set}
      />
      <ButtonConfigurator
        label="Botão secundário"
        textKey="cta_secondary" styleKey="cta_secondary_style" colorKey="cta_secondary_color"
        data={data} set={set}
      />
      <ButtonConfigurator
        label="Botão terciário"
        textKey="cta_tertiary" styleKey="cta_tertiary_style" colorKey="cta_tertiary_color"
        data={data} set={set}
      />
      <TextInput label="Link do botão terciário" value={data.cta_tertiary_href} onChange={v => set('cta_tertiary_href', v)} placeholder="/plataforma" hint="URL interna (ex: /plataforma) ou externa (https://...)" />

      <Field label="Imagens do carrossel" hint="Rotacionam a cada 5 segundos. Pode usar URL ou fazer upload.">
        <div className="space-y-3">
          {(data.image_urls || []).map((url, i) => (
            <div key={i} className="flex gap-2 items-start">
              <div className="flex-1">
                <ImageUpload
                  value={url}
                  onChange={v => {
                    const arr = [...(data.image_urls || [])];
                    arr[i] = v;
                    set('image_urls', arr);
                  }}
                />
              </div>
              <button
                onClick={() => set('image_urls', (data.image_urls || []).filter((_, idx) => idx !== i))}
                className="text-gray-400 hover:text-red-500 mt-2.5 p-1"
              >
                <span className="material-icons text-lg">close</span>
              </button>
            </div>
          ))}
          <button
            onClick={() => set('image_urls', [...(data.image_urls || []), ''])}
            className="text-sm text-blue-600 hover:text-blue-700 font-medium flex items-center gap-1"
          >
            <span className="material-icons text-base">add</span> Adicionar imagem
          </button>
        </div>
      </Field>
    </div>
  );
};

export default HeroEditor;
